import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, " Formulario ", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex flex-col h-full" }
const _hoisted_5 = { class: "flex-none w-3/6 items-start" }
const _hoisted_6 = { class: "flex-1 bg-success/30 border-gray-200 h-full items-center" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center bg-success/30 border-gray-200 justify-center h-full"
}
const _hoisted_8 = ["onUpdate:modelValue", "name"]
const _hoisted_9 = ["for"]
const _hoisted_10 = ["onUpdate:modelValue", "name"]
const _hoisted_11 = ["for"]
const _hoisted_12 = {
  key: 1,
  class: "flex items-center bg-success/30 border-gray-200 justify-center h-full"
}
const _hoisted_13 = {
  key: 2,
  class: "flex items-center bg-success/30 border-gray-200 justify-center h-full"
}
const _hoisted_14 = { class: "flex-1" }
const _hoisted_15 = { class: "flex justify-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "flex justify-end m-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailsModalForm = _resolveComponent("DetailsModalForm")!
  const _component_Selector = _resolveComponent("Selector")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_ComponentCard = _resolveComponent("ComponentCard")!
  const _component_ModalAlert = _resolveComponent("ModalAlert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.answers) + " " + _toDisplayString(_ctx.communityId) + " ", 1),
    (_ctx.showDetails && _ctx.questionDetails )
      ? (_openBlock(), _createBlock(_component_DetailsModalForm, {
          key: 0,
          visible: _ctx.showDetails,
          blockId: _ctx.blockId,
          index: _ctx.indexDetails,
          questions: _ctx.questions,
          question: _ctx.questionDetails,
          onCloseModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDetails = false)),
          data: _ctx.dataAnswer,
          onCreate: _ctx.responseUpdate
        }, null, 8, ["visible", "blockId", "index", "questions", "question", "data", "onCreate"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ComponentCard, { class: "flex h-full" }, {
      header: _withCtx(() => [
        _hoisted_2,
        (_ctx.questionnaire?.answers)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " cuestionario completado. "))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question, index) => {
            return (_openBlock(), _createElementBlock("article", {
              class: "flex w-full h-max-20 h-24 items-center gap-4 p-4",
              key: question.id
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(index + 1) + " " + _toDisplayString(question.content), 1),
              _createElementVNode("div", _hoisted_6, [
                (question.answerTypeFront == 'RADIAL')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _withDirectives(_createElementVNode("input", {
                        id: "bordered-radio-1",
                        type: "radio",
                        "onUpdate:modelValue": ($event: any) => ((question.responseForm) = $event),
                        value: "true",
                        name: 'bordered-radio-' + question.id,
                        class: "w-4 h-4 text-success bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-success dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      }, null, 8, _hoisted_8), [
                        [_vModelRadio, question.responseForm]
                      ]),
                      _createElementVNode("label", {
                        for: 'bordered-radio-1-' + question.id,
                        class: "ml-2 mr-4 text-sm font-medium text-success"
                      }, "Si", 8, _hoisted_9),
                      _withDirectives(_createElementVNode("input", {
                        id: "bordered-radio-2",
                        type: "radio",
                        "onUpdate:modelValue": ($event: any) => ((question.responseForm) = $event),
                        value: "false",
                        name: 'bordered-radio-' + question.id,
                        class: "w-4 h-4 text-success bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-success dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      }, null, 8, _hoisted_10), [
                        [_vModelRadio, question.responseForm]
                      ]),
                      _createElementVNode("label", {
                        for: 'bordered-radio-2-' + question.id,
                        class: "ml-2 text-sm font-medium text-success"
                      }, "No", 8, _hoisted_11)
                    ]))
                  : _createCommentVNode("", true),
                (question.answerTypeFront == 'SELECTOR')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                      _createVNode(_component_Selector, {
                        class: "w-3/4 mr-6",
                        selectedItem: Number(_ctx.tipoSelector),
                        items: _ctx.formSelector,
                        onUpdate: _ctx.onUpdateSelector
                      }, null, 8, ["selectedItem", "items", "onUpdate"])
                    ]))
                  : _createCommentVNode("", true),
                (question.answerTypeFront == 'INPUT' )
                  ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
                      _createVNode(_component_TextField, {
                        class: "w-3/4 mr-6",
                        placeholder: 'Escribir Tipo',
                        type: "numeric",
                        model: question.responseForm,
                        "onUpdate:model": ($event: any) => ((question.responseForm) = $event),
                        name: 'text' + question.id
                      }, null, 8, ["model", "onUpdate:model", "name"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("aside", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  (!question.isCondition)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _withModifiers(($event: any) => (_ctx.details(index,question)), ["stop"]),
                        class: "cursor-pointer flex ml-2 my-2 rounded-md text-white bg-success hover:bg-green-600 focus:bg-green-600 px-2 py-2"
                      }, " Completar detalles ", 8, _hoisted_16))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("footer", _hoisted_17, [
          _createElementVNode("button", {
            class: "bg-success hover:bg-green-500 text-white font-bold py-2 px-4 rounded",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveForm && _ctx.saveForm(...args)))
          }, " Guardar Formulario ")
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ModalAlert, {
      title: _ctx.title,
      message: _ctx.message,
      visible: _ctx.visible,
      option: false,
      onAccept: _ctx.handleAccept,
      onCancelAlert: _ctx.handleCloseSuccess
    }, null, 8, ["title", "message", "visible", "onAccept", "onCancelAlert"])
  ]))
}